import type { ReactNode } from 'react'
import type Shipment from '../../../types/api/shipment'
import { DataSourceItem } from '../shipments-page'

export const onCellStandard = (v: DataSourceItem, r: any) => {
    return {
        // rowSpan: v.rowSpan,
    }
}

export const renderShipment = (
    render: (shipment: Shipment, value: any, index: number) => ReactNode | undefined
) => {
    return (value: any, record: DataSourceItem, index: number) => {
        return render(record, value, index)
    }
}

export const onAnyStandardCell = (_record: DataSourceItem) => ({ colSpan: 1 })